import React from "react";
import { object } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import SmallStoryCardWithTopBorder from "../molecules/smallStoryCardWithTopBorder";
import { More } from "../atoms/load-more-btn";

import "./author.m.css";

const AuthorPageBase = ({ data = {}, hostUrl }) => {
  const { stories, author, pageNumber } = data;

  if (!(stories && stories.length && author)) {
    return null;
  }

  const slug = `${hostUrl}/author/${author.id}/${author.slug}?page=${pageNumber ? parseInt(pageNumber) + 1 : 2}`;

  return (
    <div>
      <h1 styleName="heading">{`লেখক - ${author.name}`}</h1>
      {stories.map(story => (
        <SmallStoryCardWithTopBorder story={story} key={story.key} />
      ))}
      {stories.length > 10 && (
        <a styleName="button-container" href={slug}>
          <More text="আরও" />
        </a>
      )}
    </div>
  );
};

AuthorPageBase.propTypes = {
  data: object,
  config: object
};

const mapStateToProps = state => {
  return {
    hostUrl: get(state, ["qt", "config", "publisher-attributes", "host_url"], {})
  };
};

export const AuthorPage = connect(mapStateToProps)(AuthorPageBase);
